export default __webpack_public_path__ + "static/media/carousel (2).1cb2caf3.jpg";